export default __webpack_public_path__ + "assets/trucks-book-loads.3aa7d49d02a2e35a79b056662b1dc445.jpg";